import i18n from '@opsbase/lib-i18n';
import Pages from '@opsbase/lib-pages';
import Palette from '@opsbase/lib-palette';
import { DateTimeFormat } from '@opsbase/lib-time/consts/index';
import useCss from '@opsbase/web-css';
import Horizontal from '@opsbase/web-layout/Horizontal';
import useNav from '@opsbase/web-nav/useNav';
import Button from '@opsbase/web-ui/Button';
import Text from '@opsbase/web-ui/Text';
import React, { useCallback, useMemo } from 'react';
const makeMyClasses = valid => ({
    root: {
        backgroundColor: valid ? Palette.NoteYellow.main : Palette.BadRed.light,
        border: `1px solid ${Palette.LineGrey.main}`,
        borderRadius: 4,
    },
});
const QuestionSetEditCallToPublish = ({ questionSet, isPublishRequired, }) => {
    var _a;
    const { goTo } = useNav();
    const isValid = useMemo(() => { var _a; return ((_a = questionSet === null || questionSet === void 0 ? void 0 : questionSet.form) === null || _a === void 0 ? void 0 : _a.length) > 0; }, [questionSet]);
    const myCss = useCss(makeMyClasses, [isValid]);
    const handlePublish = useCallback(() => {
        goTo(Pages.QUESTION_SETS_PUBLISH, { id: questionSet.id });
    }, [goTo, questionSet]);
    return (React.createElement(Horizontal, { shrink: true, padding: true, justify: "flex-end", centered: true, gutter: true, classes: { root: myCss.root } },
        !isValid && (React.createElement(Text, null, i18n.t('form-invalid-update') +
            ' - ' +
            i18n.t('fail-constraint-min', { min: 1 }))),
        isValid ? ((questionSet === null || questionSet === void 0 ? void 0 : questionSet.lastPublishedDate) ? (React.createElement(Text, null, i18n.t('last-updated-on') +
            ' ' +
            ((_a = questionSet.lastPublishedDate) === null || _a === void 0 ? void 0 : _a.format(DateTimeFormat)))) : null) : undefined,
        isValid && (React.createElement(Button, { color: Palette.warning, onClick: handlePublish, small: true, disabled: !isPublishRequired, label: i18n.t('update') }))));
};
export default QuestionSetEditCallToPublish;
